import { Box, xcss } from '@atlaskit/primitives';
import EllipsisOverflow from '@databases/field-value/common/EllipsisOverflow';
import { messages } from '@databases/intl/messages';
import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

export interface DatabaseNameViewProps {
  name: string;
}

const DatabaseNameView: FunctionComponent<DatabaseNameViewProps> = ({ name }) => {
  const { formatMessage } = useIntl();

  return (
    <Box
      xcss={xcss({
        padding: 'space.050',
        color: !name ? 'color.text.subtlest' : 'color.text',
        width: '100%',
      })}
    >
      <EllipsisOverflow position="bottom-start" testId="view-database-name">
        {name || formatMessage(messages['unnamed-entities.untitled-database'])}
      </EllipsisOverflow>
    </Box>
  );
};

export default DatabaseNameView;
